import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { Mutations } from '@shared/api';

import { API } from '@shared/types/api';
type DeleteEntitiesFunction = (ids: string[]) => Promise<true>;

export function useDeleteEntitiesMutation(workflowTemplateId: string): DeleteEntitiesFunction {
  const [deleteEntities] = useMutation<
    API.DeleteWorkflowEntitiesMutation,
    API.DeleteWorkflowEntitiesMutationVariables
  >(Mutations.entity.deleteWorkflowEntities);

  return useCallback(
    async (ids: string[]) => {
      const input = {
        workflowTemplateId,
        ids,
      };
      const { data } = await deleteEntities({
        variables: { input },
      });

      const success = data?.deleteWorkflowEntities;

      if (success) {
        return success;
      } else {
        throw new Error('Failed to delete entities');
      }
    },
    [workflowTemplateId, deleteEntities],
  );
}
